/** Use this Script if you has JS Functions that are used in multiple Blocks.
 */
// import Swiper bundle with all modules installed
import Swiper from 'swiper/bundle';
// import styles bundle
import 'swiper/css/bundle';

class FeatureTeaserBlock {
	constructor() {
		this.featureData = [];
		this.featureCatData = [];
		this.loadMax = $('#feature-raster').data('load-max');
		this.translatedHTML = $('#feature-raster').data('translate');
		this.notRenderedFeatures = [];
	}

	async init() {
		if ($('.feature-teaser-block').length > 0) {
			await this.setFeaturesDataFromJSON();
			await this.setCategoryData();

			if (this.featureData.length === 0) {
				console.log('No features found in JSON');
			} else {
				console.log('Features found in JSON');
				console.log(this.featureData);
			}

			this.setupEventHandlers();
		}
	}

	setupEventHandlers() {
		$('.feature-teaser-block .click-category-filter').on(
			'click',
			(event) => {
				let catId = $(event.currentTarget).data('cat-id');
				if ($(event.currentTarget).hasClass('active')) {
					$('.click-category-filter').removeClass('active');
					this.updateFeatureRaster(this.featureData);
				} else {
					$('.click-category-filter').removeClass('active');
					$(event.currentTarget).addClass('active');
					this.activateCategoryFilter(catId);
				}
			}
		);

		$('#feature-teaser-block-search').on('input', (event) => {
			this.activateSearchFilter(event.currentTarget);
		});

		$('.feature-teaser-block .load-more-button').on('click', () => {
			this.loadMax = 999;
			$('.feature-teaser-block .load-more-button').remove();
			this.outputFeatures(this.notRenderedFeatures);
		});
	}

	activateCategoryFilter(catId) {
		let foundFeatures = this.returnFoundFeatures(catId);
		this.updateFeatureRaster(foundFeatures);
	}

	activateSearchFilter(input) {
		let searchValue = $(input).val().toLowerCase();

		let foundFeatures = this.featureData.filter(
			(feature) =>
				feature.title.rendered.toLowerCase().includes(searchValue) ||
				feature.content.rendered.toLowerCase().includes(searchValue) ||
				feature.excerpt.rendered.toLowerCase().includes(searchValue)
		);
		this.updateFeatureRaster(foundFeatures);
	}

	updateFeatureRaster(foundFeatures) {
		$('#feature-raster').empty();
		if (foundFeatures.length === 0) {
			$('#feature-raster').append(
				`<p>${this.translatedHTML.no_features}</p>`
			);
		} else {
			this.outputFeatures(foundFeatures);
		}
	}

	async setCategoryData() {
		if (this.featureCatData.length > 0) {
			return;
		}
		$('.click-category-filter').each((index, element) => {
			let catId = $(element).data('cat-id');
			let name = $(element).text();
			let imgSrc = $(element).find('img').attr('src');
			this.featureCatData.push({ catId, name, imgSrc });
		});
	}

	getCategoryArray(feature) {
		let catIds = feature.feature_category;
		return this.featureCatData.filter((cat) => catIds.includes(cat.catId));
	}

	createFeatureBoxHTML(feature, categoryHTML) {
		// get posttype relaase date
		const release_date = new Date(feature.date).toLocaleDateString('de-DE', {
			day: '2-digit',    // Stellt sicher, dass der Tag immer zweistellig ist
			month: '2-digit',  // Stellt sicher, dass der Monat immer zweistellig ist
			year: 'numeric'    // Gibt das Jahr vierstellig aus
		});
		return `
            <div class="feature-box" data-feature-id="${feature.id}">
                 <div class="category-filter">${categoryHTML}</div>
                <div class="title has-h-3-font-size">${feature.title.rendered}</div>
                <!-- <div class="feature-update-status-dates">
                    <div>
                         <svg width="15" height="15" viewBox="0 0 15 15" fill="none"> <rect width="15" height="15" fill="url(#pattern0_189_8)" /> <defs> <pattern id="pattern0_189_8" patternContentUnits="objectBoundingBox" width="1" height="1"> <use xlink:href="#image0_189_8" transform="scale(0.01)" /> </pattern> <image id="image0_189_8" width="100" height="100" xlink:href="data:image/png;base64,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" /> </defs> </svg>
                        <span> ${this.translatedHTML.released}: ${release_date}</span>
                    </div>
                </div> --> 
                <p>${feature.excerpt.rendered}</p>
				<a class="readmore wp-block-button__link has-palettecolor-8-color has-palettecolor-1-background-color"
                href="${feature.link}"> 
                <span>${this.translatedHTML.Read_more}</span>
          		  </a>
            </div>
        `;
	}

	outputFeatures(foundFeatures) {
		this.notRenderedFeatures = [];

		foundFeatures.forEach((feature, index) => {
			if (index >= this.loadMax) {
				this.notRenderedFeatures.push(feature);
			} else {
				let categoryHTML = this.createCategoryHTML(
					this.getCategoryArray(feature)
				);
				let featureBoxHTML = this.createFeatureBoxHTML(
					feature,
					categoryHTML
				);
				$('#feature-raster').append(featureBoxHTML);
			}
		});
	}

	createCategoryHTML(categories) { //
		// cat.name.replace(/<img[^>]*>/g, '').trim()}  == removes img tag from category name 
		return categories
			.map(
				(cat) =>
					`<div class="category-btn"> ${cat.imgSrc ? '<img src="' + cat.imgSrc + '" alt=""/>' : ''}  <span class="text">${cat.name.replace(/<img[^>]*>/g, '').trim()}</span>   </div>`
			)
			.join('');
	}

	returnFoundFeatures(catId) {
		return this.featureData.filter((feature) =>
			feature.feature_category.includes(catId)
		);
	}

	async setFeaturesDataFromJSON() {
		let siteUrl = window.location.origin;

		if (this.featureData.length > 0) {
			return true;
		}

		try {
			let response = await $.ajax({
				url: siteUrl + '/wp-json/wp/v2/features',
				type: 'GET'
			});
			this.featureData = response;
			return true;
		} catch (error) {
			console.error('Error updating feature raster:', error);
			return false;
		}
	}
}

jQuery(document).ready(($) => {
	const featureTeaserBlock = new FeatureTeaserBlock();
	featureTeaserBlock.init();


	var swiper = new Swiper(".roadmap-slider", {
		navigation: {
			nextEl: ".roadmap-slider .roadmap-swiper-button-prev",
			prevEl: ".roadmap-slider .roadmap-swiper-button-next",
		},
		slidesPerView: "auto",
	});


});



